// extracted by mini-css-extract-plugin
module.exports = {"sectionArticleMobile":"Discover_sectionArticleMobile__Nonmy","sectionArticle":"Discover_sectionArticle__wFK1I"};